<label class="switch border-grey-bluish">
  <input type="checkbox" [checked]="isChecked" (change)="toggleSwitch($event)" />
  <span class="slider"></span>
</label>
